import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Initial } from '../models/Initial';
@Component({
  selector: 'app-initial',
  templateUrl: './initial.component.html'
})
export class InitialComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'Initial'
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;

	@Input() initial : Initial;

  constructor() { }

  public ngOnInit() {
  }








  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }


}

